// extracted by mini-css-extract-plugin
export var childrenContent = "bJ_fs";
export var content = "bJ_L";
export var titleContent = "bJ_ft";
export var titleContentLabel = "bJ_fv";